/* eslint-disable no-useless-escape */
const Validators = {
  email(email) {
    return (
      email.match(
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      ) !== null
    );
  }
};

export default Validators;
